<template>
  <div
    class="loader"
    :class="externalClass"
  >
    <Icon
      icon="r-loader"
      class="loader__icon"
    />
  </div>
</template>

<script>
import Icon from './Icon.vue';
import '../../../../../svg-icons/r-loader.svg';

export default {
  name       : 'LoaderUI',
  components : { Icon },
  props      : {
    modify: {
      type    : [String, Array],
      default : ''
    }
  },
  computed: {
    externalClass() {
      if (this.modify && Array.isArray(this.modify)) {
        return this.modify.map((el) => `loader--${el}`).join(' ');
      }
      if (this.modify) {
        return `loader--${this.modify}`;
      }

      return '';
    }
  }
};
</script>

<style scoped lang="scss">
.loader {
  position: relative;
  display: block;
  width: 100%;
  min-height: 60px;
  min-width: 100px;

  @media (min-width: 768px) {
    min-height: 100px;
  }
  &__icon {
    position: absolute;
    left: 50%;
    top: 50%;
    max-width: 40px;
    width: 40px;
    height: 40px;
    transform: translate(-50%, -50%);
    color: #003595;

    @media (min-width: 768px) {
      max-width: 60px;
      width: 60px;
      height: 60px;
    }
  }
  &--absolute {
    position: absolute;
    z-index: 9;
    top: 0;
    left: 0;
    height: 100%;
  }
  &--small {
    min-height: 40px;

    @media (min-width: 768px) {
      min-height: 60px;
    }
    .loader__icon {
      max-width: 30px;
      width: 30px;
      height: 30px;

      @media (min-width: 768px) {
        max-width: 40px;
        width: 40px;
        height: 40px;
      }
    }
  }
  &--xxs {
    width: auto;
    min-width: 16px;
    min-height: 16px;

    .loader__icon {
      max-width: 16px;
      width: 16px;
      height: 16px;
    }
  }
  &--icon {
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;

    .loader__icon {
      max-width: 22px;
      width: 22px;
      height: 22px;
    }
  }
}
</style>
